import React, { useState, useEffect, useRef ,useLayoutEffect } from 'react';

import classnames from 'classnames';

export default function StickyHeader(props){

  const [scrolled,setScrolled] = useState(false);

  const divRef = useRef(null);

  useEffect(() => {
    window.addEventListener("scroll", isSticky);
    return () => {
      window.removeEventListener("scroll", isSticky);
    };
  }, []);

  const isSticky = () => {
    const scrollTop = window.scrollY;
    const pixelsFromTop = divRef.current.offsetTop;
    setScrolled(scrollTop >=pixelsFromTop);
  };

  let stickyContainerClasses = classnames(
    'sticky-container',
    {
      'd-none': !props.show,
    },
    {
      'd-block': props.show,
    },
  );

  let stickyClasses = classnames(
    'sticky-header',
    {
      'sticky': scrolled,
    });

  return(<div className={stickyContainerClasses} ref={divRef}>
    <div className={stickyClasses}>
      <div className="sticky-content">
      {props.children}
      </div>
    </div>
  </div>);
}
